<template>
<div class="alarmHistory">
  <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
    <alarm-drawer :editData="selectData" v-if="drawerShow"></alarm-drawer>
  </el-drawer>
  <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="handleDrawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
    <handle-drawer :handleId="handleId" :policeContent="policeContent" :handleType="handleType" :fbdate="fbdate" :fedate="fedate" :alarmTime="alarmTime" :imgTycl="imgTycl" v-if="handleDrawerShow" @confirm="handleConfirm" :loading.sync="loading" @cancel="handleDrawerShow = false" :isDisabled="isDisabled" :handleObj="handleObj" :isSelectAll="isSelectAll"></handle-drawer>
  </el-drawer>
  <div class="mainContent" :style="styleObject">
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
        <!-- <el-tree v-if="1" class="tree" ref="tree" :indent=6 :data="treeData" node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree> -->
      </div>
    </div>
    <div class="container">
      <div class="query newDate" v-if="rolePermit('alarm:excel')||rolePermit('alarm:query')">
        <div v-if="rolePermit('alarm:query')">
          <el-date-picker v-model="creatTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
          </el-date-picker>
          <el-select v-model="devtypeid" placeholder="设备类型" clearable>
            <el-option v-for="item in devtypeoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <!-- <el-select v-model="zoneid" placeholder="报警区域" clearable>
            <el-option v-for="item in zoneoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select v-model="handleState" placeholder="处理进度" clearable>
            <el-option v-for="item in handleoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="handleTypes" placeholder="处理类型" clearable>
            <el-option v-for="item in handleTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input placeholder="请输入报警内容" v-model="content" style="width:130px;"></el-input>
          
          <div class="el-bt">
            <el-input placeholder="IMEI/设备名称/设备类型" v-model="IMEI" style="width:200px;"></el-input>
            <el-tooltip effect="light" content="IMEI/设备名称/设备类型(按前几位进行搜索)" placement="top">
              <span class="icon-btn el-icon-warning-outline"></span>
            </el-tooltip>
          </div>
          <!-- <el-select v-model="alarmLevel" placeholder="报警等级" clearable>
            <el-option v-for="item in leveloptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select> -->
          <button class="primaryBtn" v-if="rolePermit('alarm:query')" @click="serachData">搜索</button>
          <!-- v-if="isPermit('alarm:dispose')" -->
          <!-- <button class="primaryBtn" @click="exportTable" v-if="rolePermit('alarm:excel') &&  currentTreeId != -1"><span style="color:#fff">报表导出</span></button> -->
          <!-- <button v-if="rolePermit('alarm:handle') &&  currentTreeId != -1" :class="['primaryBtn', 'btns', selData.length ?'':'active']" @click="dealDialogAll">批量处理</button> -->
          <!-- 终端区域不隐藏报表导出 批量处理 -->
          <button class="primaryBtn" @click="exportTable" v-if="rolePermit('alarm:excel')"><span style="color:#fff">报表导出</span></button>
          <button v-if="rolePermit('alarm:handle')" :class="['primaryBtn', 'btns', selData.length ?'':'active']" @click="dealDialogAll">批量处理</button>
        </div>
      </div>
      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="alarmCurrentChange" @sizeChange="alarmSizeChange" @selectionChange="handleSelectionChange" @handleDragend="handleDragend" :border="true">
        <el-table-column type="selection" width="50" :selectable="({ isHandle }) => !isHandle"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" :show-overflow-tooltip="true" width="90"></el-table-column>
        <!-- <el-table-column prop="deviceId" label="设备ID" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="deviceIMEI" label="IMEI" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="deviceType" label="设备类型" :show-overflow-tooltip="true" min-width="90">
          <template slot-scope="scope">
            <div>{{handleTypeConvert(scope.row.deviceType, typeOptions)}}</div>
            <!-- <div>{{scope.row.deviceType ? typeOptions.find((e) => e.id === scope.row.deviceType).name: ''}}</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="deviceRegistTo" label="使用人" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div>{{scope.row.bingUserTel}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="regionName" label="区域" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="deviceInstallLocation" label="安装位置" :show-overflow-tooltip="true" min-width="90"></el-table-column>
        <el-table-column prop="createTime" label="报警时间" :show-overflow-tooltip="true" width="160px"></el-table-column>
        <el-table-column prop="content" label="报警内容" :show-overflow-tooltip="true" min-width="90"></el-table-column>
        <el-table-column prop="handleTime" label="处理时间" :show-overflow-tooltip="true" width="160px"></el-table-column>
        <el-table-column prop="handleType" label="处理类型" :show-overflow-tooltip="true" min-width="90">
          <template slot-scope="scope">
            <span>{{scope.row.handleType == 1 ? '误报' : scope.row.handleType == 2 ? '真实报警' : scope.row.handleType == 3 ? '故障' : scope.row.handleType == 4 ? '测试' : scope.row.handleType == 5 ? '其他' : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isHandle" label="处理状态" :show-overflow-tooltip="true" min-width="90">
          <template slot-scope="scope">
            <span :style="{background : scope.row.isHandle ? '#00b050' : '#ff0000', color:'#fff', padding: '0 5px', borderRadius: '2px'}" :disabled="scope.row.isHandle">{{scope.row.isHandle ? '已处理' : '未处理'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="通知记录" :show-overflow-tooltip="true" v-if="rolePermit('alarm:query')" min-width="90">
          <template slot-scope="scope">
            <el-button @click="seeClick(scope.row)" size="small" class="edit">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" fixed="right" width="200px" v-if="rolePermit('alarm:handle')">
            <template slot-scope="scope">
               <el-button type="text" icon="el-icon-s-claim" v-if="!scope.row.isHandle && rolePermit('alarm:handle')" @click="dealDialog(scope.row)">处理</el-button>
               <el-button type="text" icon="el-icon-s-claim" v-if="scope.row.isHandle" @click="dealDialog(scope.row)">查看处理原因</el-button>
            </template>
        </el-table-column>
      </border-table>
    </div>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import AlarmDrawer from "@/components/alarmHistory/AlarmDrawer";
import HandleDrawer from "@/components/alarmHistory/HandleDrawer";

export default {
  components: {
    BorderTable,
    AlarmDrawer,
    HandleDrawer
  },
  data() {
    return {
      treeData: [],
      currentTreeId: 0,
      treeHandler: false,
      fbdate: null,
      fedate: null,
      creatTime: [],
      pickerOptions: {
        shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      devtypeoptions: [],
      // zoneoptions: [],
      handleoptions: [{
          value: false,
          label: '未处理'
        },
        {
          value: true,
          label: '已处理'
        }
      ],
      handleTypeList: [
        {
          value: '1',
          label: '误报'
        },
        {
          value: '2',
          label: '真实报警'
        },
        {
          value: '3',
          label: '故障'
        },
        {
          value: '4',
          label: '测试'
        },
        {
          value: '5',
          label: '其他'
        },
      ],
      // leveloptions: [{
      //     value: 1,
      //     label: '一级报警'
      //   },
      //   {
      //     value: 2,
      //     label: '二级报警'
      //   },
      //   {
      //     value: 3,
      //     label: '三级报警'
      //   }
      // ],
      selectedName: "",
      radio: "1",
      names: "",
      styleObject: {
        height: ""
      },
      tableLoading: false,
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      drawerTitle: "",
      drawerWidth: "550px",
      devtypeid: '',
      // zoneid: null,
      handleState: '',
      handleTypes: '',
      // alarmLevel: null,
      handleType: '',
      selectData: {},
      params: {},
      paramdata: '',
      handleDrawerShow: false,
      handleId: '',
      alarmTime: '',
      content: '',
      IMEI: '',
      policeContent: '',
      typeOptions: [],
      imgTycl: [],
      isDisabled: false,
      handleObj: {
        type: '',
        describe: '',
      },
      selData: [],
      isSelectAll: true,
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
    };
  },
  created() {
    let { isHandle } = this.$route.params
    console.log(123123132, isHandle)
    this.handleState = isHandle
    // console.log(this.storage.getSession("sysStartTime"));

    // this.creatTime[0] = this.formatterDate(this.storage.getSession("sysStartTime"));
    // this.creatTime[1] = new Date();

    this.makeheight();
    // this.loaddectypelist();
    // this.loadzonelist();
    // this.queryTreeNode()
    this.getDeviceTypeAll()
  },
  methods: {
    async getDeviceTypeAll() {
      const {
        code,
        data,
        msg
      } = await this.request.get("/front/device/class/all")
      if (code !== 200) {
        return
      }
      this.typeOptions = data
      this.devtypeoptions = data
      // this.reloaTable();
    },
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // 查询区域 - 不用
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);

          this.treeData = rs.code === 200 ? rs.data : [];
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.reloaTable()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.reloaTable()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
        })        
      }
    },
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.reloaTable();
    },
    serachData() {
      //查询//搜索
      this.pagination.currentPage = 1;
      this.reloaTable();
    },
    // alarmLevelformat(row) {
    //   if (row.alarmLevel == 1) {
    //     return "一级报警";
    //   } else if (row.alarmLevel == 2) {
    //     return "二级报警";
    //   } else if (row.alarmLevel == 3) {
    //     return "三级报警";
    //   }
    // },
    //表格当前页变化时
    alarmCurrentChange(val) {
      this.pagination.currentPage = val;
      this.reloaTable();
    },
    handleSelectionChange (row) {
      this.selData = row
    },
    handleDragend (newWidth, oldWidth, column, event) {
      console.log(newWidth, oldWidth, column, event)
    },
    //表格展示条数变化时
    alarmSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloaTable();
    },
    getCurrentYear() {
      // 鸡肋
      if (this.creatTime != null && this.creatTime.length) {
        let date = new Date();
        let y = date.getFullYear();

        let date0 = this.creatTime[0];
        let y0 = date0.getFullYear();

        let date1 = this.creatTime[1];
        let y1 = date1.getFullYear();

        let date2 = this.creatTime[0];
        let y2 = this.formatDate(date2)
        let data3 = this.formatterDate(this.storage.getSession("sysStartTime"));
        let y3 = this.formatDate(data3)

        if (y0 > y) {
          return this.msg.error('输入开始日期年份大于当前年份，请重新输入！')
        } else if (y1 > y) {
          return this.msg.error('输入结束日期年份大于当前年份，请重新输入！')
        } else if (y3 > y2) {
          return this.msg.error('选择时间小于系统开始时间，请重新输入！')
        } else {
          // this.tableLoading = true
          this.fbdate = this.formatDate(this.creatTime[0]);
          this.fedate = this.formatDate(this.creatTime[1]);
          // this.params = {
          //   "content": this.content,
          //   "startTime": this.fbdate,
          //   "endTime": this.fedate,
          //   "isHandle": this.handleState,
          //   "orgId": this.currentTreeId?this.currentTreeId:0,
          //   "page": this.pagination.currentPage,
          //   "pageSize": this.pagination.pageSize,
          //   "sort": "createTime",
          //   "order": "desc"
          // }
          // this.request.post("/front/alarm/record/query", this.params).then(res => {
          //   if (res.code == 200) {
          //     this.tableLoading = false
          //     this.dataList = res.data.data;
          //     this.pagination.total = res.data.totalCount;
          //   } else if (res.code == 500) {
          //     this.msg.warn(res.msg);
          //     // this.msg.warn("查询月份的报警分表不存在")
          //   }
          // }).catch(error => {
          //   console.log(error)
          // })
        }
      } else {
        this.fbdate = ''
        this.fedate = ''
      }
      // else {
      //   // this.msg.warn("请选择开始日期和结束日期！")
      //   this.params = {
      //     "content": this.content,
      //     "startTime": '',
      //     "endTime": '',
      //     "isHandle": this.handleState,
      //     "orgId": this.currentTreeId?this.currentTreeId:0,
      //     "page": this.pagination.currentPage,
      //     "pageSize": this.pagination.pageSize,
      //     "sort": "createTime",
      //     "order": "desc"
      //   }
      //   this.request.post("/front/alarm/record/query", this.params).then(res => {
      //     if (res.code == 200) {
      //       this.tableLoading = false
      //       this.dataList = res.data.data;
      //       this.pagination.total = res.data.totalCount;
      //     } else if (res.code == 500) {
      //       // this.msg.warn("查询月份的报警分表不存在")
      //       this.msg.warn(res.msg)
      //     }
      //   }).catch(error => {
      //     console.log(error)
      //   })
      // }
      this.params = {
        "content": this.content,
        "key": this.IMEI,
        "startTime": this.fbdate,
        "endTime": this.fedate,
        "isHandle": this.handleState,
        "type": this.devtypeid,
        "handleType": this.handleTypes,
        "orgId": this.currentTreeId?this.currentTreeId:0,
        "page": this.pagination.currentPage,
        "pageSize": this.pagination.pageSize,
        "sort": "createTime",
        "order": "desc"
      }
      this.tableLoading = true

      let url = this.params.orgId == -1 ? '/front/alarm/record/queryOutbound' : '/front/alarm/record/query'
      this.request.post(url, this.params).then(res => {
        this.tableLoading = false
        if (res.code == 200) {
          this.dataList = res.data.data;
          this.pagination.total = res.data.totalCount;
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
          // this.msg.warn("查询月份的报警分表不存在")
        }
      }).catch(error => {
        console.log(error)
      })
    },
    reloaTable() {
      this.getCurrentYear()
    },
    formatDate(d) {
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day+" "+hours+":"+min+":"+sec;
      return times;
    },
    formatterDate(date) {
      let result = new Date(date);
      return result;
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    seeClick(row) {
      this.drawerShow = true;
      this.drawerTitle = "通知记录";
      this.handleType = 'seeDetail';
      this.selectData = row;
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    exportTable() {
      this.$confirm('此操作将导出报表, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let getparams = "page=" + parseInt(this.pagination.currentPage) + "&pageSize=" + parseInt(this.pagination.pageSize);
        if (this.devtypeid) {
          getparams += "&type=" + this.devtypeid;
        }
        if (this.handleTypes) {
          getparams += "&handleType=" + this.handleTypes;
        }
        // if (this.zoneid) {
        //   getparams += "&zoneId=" + this.zoneid;
        // }
        // console.log(1122345, this.handleState)
        if (this.handleState != undefined) {
          getparams += "&isHandle=" + this.handleState;
        }
        if (this.content) {
          // console.log(this.content);
          getparams += "&content=" + this.content;
        }
        if (this.IMEI) {
          getparams += "&imei=" + this.IMEI;
        }
        if (this.currentTreeId) {
          // console.log(this.currentTreeId);
          getparams += "&orgId=" + this.currentTreeId;
        }
        if (this.creatTime != undefined && this.creatTime.length) {
          if (this.creatTime[0]) {
            getparams += "&startTime=" + this.formatDate(this.creatTime[0])
          }
          if (this.creatTime[1]) {
            getparams += "&endTime=" + this.formatDate(this.creatTime[1])
          }
        } else {
          getparams += "&startTime= " + "&endTime= "
        }
        this.paramdata = getparams;
        window.open(this.baseUrlAddr + '/front/alarm/record/download?' + this.paramdata)
        this.msg.success('导出成功')
        return
      }).catch(() => {
        this.msg.info('已取消导出')
      });
    },
    // handleAlarm(row) {
    //   this.handleId = row.id;
    //   this.alarmTime = row.createTime;
    //   this.handleDrawerShow = true;
    //   this.fbdate = this.formatDate(this.creatTime[0]);
    //   this.fedate = this.formatDate(this.creatTime[1]);
    //   this.drawerTitle = row.handleStatus === '未处理' ? "报警处理" : "处理结果";
    //   this.handleType = row.handleStatus === '未处理' ? "handle" : "result";
    // },
    dealDialog(row) {
      let { id, content, isHandle } = row
      // this.$confirm('此操作将处理报警, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   console.log(`row`, row)
        this.handleDrawerShow = true;
        this.isSelectAll = true
        this.handleId = id
        this.policeContent = content
        this.drawerTitle = "报警处理";
        this.isDisabled = isHandle
        this.handleObj = {
          type: row.handleType,
          describe: row.handleDescribe,
        }
        if (isHandle) {
          this.request.get('/front/alarm/record/alarmImg/' + id).then(res => {
            if (res.data != "无此图片") {
              this.imgTycl = res.data.deviceImg.split(';')
            }
          })
        }
      // }).catch(() => {
      //   this.msg.info('已取消处理')
      // });
    },
    /**
     * @Description 批量处理
     * @Author      YOYO     -             2022-02-16
     */
    dealDialogAll () {
      if (!this.selData.length) {
        return this.$message({ type: 'warning', message: '请勾选要处理的设备！'})
      }
      this.isDisabled = false
      this.handleDrawerShow = true;
      this.isSelectAll = false
      let idsTemp = this.selData.reduce((total, { id }) => {
            return total += `${id},`
          }, '')
      let ids = idsTemp.substr(0, idsTemp.length - 1)
      this.handleId = ids
      this.drawerTitle = "报警批量处理";
    },
    handleConfirm() {
      this.handleDrawerShow = false;
      this.reloaTable()
    },
    // 解析类型
    handleTypeConvert (row, type) {
      let temp = ''
      type.map((item) => {
        if (item.id == row) {
          temp = item.name
        }
      })
      return temp
    },
  }
};
</script>

<style lang="scss" scoped>
.alarmHistory {
  position: relative;

  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .container {
      padding-left: 260px;
    }

    // .radio{
    //    margin: 20px 0;
    // }
    .query {
      margin-bottom: 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    // .btnS{
    //    color: #2A7EE1;
    //    border:1px solid #A1C6F3;
    //    background: #EFF3FC;
    //    // margin-right:24px;
    //   &.active {
    //     // border: 1px solid red;
    //     background: #F2F2F2;
    //     color: #AAAAAA;
    //     cursor: default;
    //   }
    // }
  }
}
</style><style lang="scss">
.alarmHistory {
  .treeAside {
    position: absolute;
    width: 300px;
    height: 100%;
    padding: 15px 20px;
    left: 0;
    top: 0;
    box-sizing: border-box;

    .treeTop {
      position: absolute;
      height: 40px;
      line-height: 40px;
      font-size: 0;
      font-weight: bold;
      top: 20px;
      z-index: 10;
      // left: 30px;
      padding-left: 10px;

      .treeTopTitle {
        margin-right: 115px;
        // width: 500px;
        font-size: 18px;
        color: #333;
      }

      .el-button {
        margin-left: -24px;
      }

      .complete {
        margin-left: 10px;
      }
    }

    .treeBox {
      overflow: hidden;
      height: 100%;
      border: 1px solid #ebeef5;
      padding: 40px 0 10px;
      box-sizing: border-box;
    }

    .tree {
      height: 100%;
      overflow: auto;

      .el-tree-node__content {
        height: 40px;
      }

      .custom-tree-node {
        height: 40px;
        line-height: 40px;
        width: 100%;

        .treeLabel {
          font-size: 14px;
          display: inline-block;
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .treeBtn {
          float: right;

          .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }

  .query {
    .el-input {
      width: 380px;
      margin-right: 10px;
      margin-bottom: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }

    .el-bt {
      // border: 1px solid red;
      position: relative;
      width: 210px;
      display: inline-block;
      .icon-btn {
        position: absolute;
        top: 8px;
        right: 15px;
        font-size: 18px;
      }
    }
  }
  .newDate{
    .el-date-editor--datetimerange.el-input,.el-date-editor--datetimerange.el-input__inner{
      width: 380px;
    }
    .primaryBtn {
      // border: 1px solid red;
       // color: #2A7EE1;
       // border:1px solid #A1C6F3;
       // background: #EFF3FC;
       // margin-right:24px;
      &.active {
        // border: 1px solid red;
        background: #F2F2F2;
        color: #AAAAAA;
        cursor: default;
      }
    }
  }
  .exportBtn {
  background: #2177E6;
  color: #fff;
  padding: 11px 15px;
  height: 36px;
  line-height: 36px;
  border: none;
  font-size: 14px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin-right: 10px;
}
}


</style>
